/**
 * Call status
 */
export enum CallStatus {
    WAITING = 'waiting',
    ACTIVE = 'active',
    ON_HOLD = 'on_hold',
    FINISHED = 'finished',
}
